import { createFileRoute } from '@tanstack/react-router';

import { SupportSessionsPage, supportSessionsSearchSchema } from '@/features/organizations';

/** Every platform role reads the list; owners and admins may end a live session. */
export const Route = createFileRoute('/_authed/support-sessions')({
  staticData: { crumbKey: 'nav.supportSessions', tours: ['platform.support-sessions'] },
  validateSearch: supportSessionsSearchSchema,
  component: SupportSessionsPage,
});
